import { Component, Inject, Input, OnInit, Output, ViewChild, EventEmitter, ElementRef } from '@angular/core';
import { DataStateChangeEventArgs, FilterSettingsModel, GridComponent, IFilter, PageSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { BasicAdvance, budgetBO, columnWidth, filter, GetClientEvaluation } from './budgetimport.model';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonHttpService } from 'src/app/common.service';
import { DateService } from 'src/app/date.service';
import { budgetlistService } from './budgetimportdata.service';
import { GlobalComponent } from 'src/app/global/global.component';
import { budgetformService } from './budgetimport.service';
import { budgetService } from '../budgetplan-form/budgetplan-form.service';
import { IMyDpOptions } from 'mydatepicker';
import { DatePipe } from '@angular/common';
import { BudgetImportBO, functionpermission, ReturnBudgetBO } from '../budgetplan-form/budgetplan-form.model';
import { HttpErrorResponse } from '@angular/common/http';
import { ConfigurationService } from "src/app/configuration.service";
import * as pbi from "powerbi-client";
import { JwtHelper } from 'angular2-jwt';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-budgetimport',
  templateUrl: './budgetimport.component.html',
  styleUrls: ['./budgetimport.component.scss']
})

export class BudgetimportComponent implements OnInit {

  @Input() bugetInput: BudgetImportBO = new BudgetImportBO();
  @Output() dataemitBudgetimport = new EventEmitter<budgetBO>();
  @ViewChild("reportContainer", { static: false }) reportContainer: ElementRef;
  @ViewChild('grid') public grid: GridComponent;
  @ViewChild('gridlog') public gridlog: GridComponent;

  valuechange: any = [];
  public toolbar: ToolbarItems[];
  LogTable: any = [];
  ClientEmpList: any = [];
  ColumnArray: columnWidth[];
  budgetImprtPlan: any = [];

  Basic: BasicAdvance = new BasicAdvance()
  filterbo: filter = new filter()
  BudgetImportData: ReturnBudgetBO = new ReturnBudgetBO();
  JwtHelper: JwtHelper = new JwtHelper();
  public dataOnBoardclient: Observable<DataStateChangeEventArgs>;
  private onDestroy$: Subject<void> = new Subject<void>();

  GetClientEvaluation: GetClientEvaluation = new GetClientEvaluation();

  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    showClearDateBtn: false,
    editableDateField: true
  };

  ClinetDropDown: any;
  allClientDropDown: any;
  reportClientId: any;
  allBudgetDropDown: any;
  Token: any;
  selectedBudgetId: any;

  reportcontain: any = false;
  radioadd: any = ''
  initialPage1: PageSettingsModel;
  ftype: string = "";
  radioview: any = ''
  viewtype: string;
  isbasicadvance: boolean = false;
  public filterSettings: object;
  ModelType: string;
  fp: functionpermission;
  openform: boolean = false;
  configuration: any;
  initialPage: object;
  filterOptions: FilterSettingsModel;
  filter: IFilter;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  src: string = "./assets/pdf/CSPPlan.pdf";
  decodedToken: any;
  locationLid: any;
  OnboardList: any
  public formatOptions: object
  agencyid_boll = false;
  status: any = "Active";
  isDetailed = true;
  isSummary = false;
  isDaily = false;
  isWeekly = false;

  budgetArray: any = [
    {
      name: 'xxxxxxx',
      date: '09/12/2021',
      status: 'active'
    },
    {
      name: 'yyyyyyy',
      date: '10/12/2021',
      status: 'active'
    }
  ];

  constructor(@Inject(budgetlistService) public budgelist: budgetlistService, public commonhttp: CommonHttpService, public datepipe: DatePipe, public dateservice: DateService, public budgetform: budgetformService, public global: GlobalComponent, public budgetplanservice: budgetService, public configurationservice: ConfigurationService,public toasterservie: ToastrService) {
    this.decodedToken = this.JwtHelper.decodeToken(this.global.authtoken);

    if (this.global.OnboardingLoginType == "agencyLogin") {
      this.global.checkforlogout();
    } else if (this.global.OnboardingLoginType == "onboardLogin") {
      this.global.checkforonBoardLogout();
    }
    this.dataOnBoardclient = budgelist;
    this.configuration = this.configurationservice.getConfiguration();
  }

ReportType: 'detail' | 'summary' | null = null;
  ngOnInit(): void {
    this.isDetailed = true
    this.isSummary = false
    this.ReportType = 'detail'   
    this.onDetailSummaryChange(this.ReportType);
    var url = window.location.href;
    if (url.includes('budget-import')) {
      this.global.isViewClientBudget = false;
    }

    if (this.global.globalLocationId != null && this.global.globalLocationId != ''
      && this.global.globalLocationId != undefined) {

      this.locationLid = this.global.globalLocationId;

      this.filterSettings = { type: 'Menu' };
    }
    else {

      this.locationLid = "00000000-0000-0000-0000-000000000000";
    }
    this.getAllClientDropDown();
    this.GetClientEvaluation.status = this.status;
    this.getOnBoardFilter();
    this.toolbar = ['ColumnChooser'];
    this.fp = new functionpermission();
    this.filterOptions = { type: 'Menu' };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    this.initialPage1 = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };
  }
  onDetailSummaryChange(value: 'detail' | 'summary') {
  this.ReportType = value;

  if (value === 'detail') {
    // Auto-select Daily
    this.isDaily = true;
    this.isWeekly = false;
  }

  if (value === 'summary') {
    // Hide & reset daily/weekly
    this.isDaily = false;
    this.isWeekly = false;
  }
}

onDailyChange() {
  if (this.isDaily) {
    this.isWeekly = false;
    this.ReportType = 'detail';
  }
}

onWeeklyChange() {
  if (this.isWeekly) {
    this.isDaily = false;
    this.ReportType = 'detail';
  }
}

  dataEmitFromCDCSPlan(event) {
    this.BudgetImportData.edit = false;
    this.getOnBoardFilter();
    this.BudgetImportData.isabasicadvance = false;
  }

  budgetImport(type) {
    if (this.bugetInput.clientId != '00000000-0000-0000-0000-000000000000'
      && this.bugetInput.clientId != null && this.bugetInput.clientId != undefined) {
      this.BudgetImportData.clientId = this.bugetInput.clientId;
    }
    this.BudgetImportData.edit = true;
    this.BudgetImportData.id = '00000000-0000-0000-0000-000000000000';
    this.budgetImprtPlan = null

    if (type == "Basic View") {
      this.Basic.isbasicview = true;
    }
    else if (type == "Advance View") {
      this.Basic.isbasicview = false;
    }
  }

  type(type) {
    if (type == "Basic View") {
      this.Basic.isbasicview = true;
      this.BudgetImportData.edit = true
    }
    else if (type == "Advance View") {
      this.Basic.isbasicview = false;
      this.BudgetImportData.edit = true
    }
  }

  statusChangeCall(val) {
    this.GetClientEvaluation.status = val;
    this.getOnBoardFilter();
  }

  reportPopup() {
    this.reportClientId = null;
    this.selectedBudgetId = null;
    document.getElementById("OpenreportFilter").click();
    if (this.global.OnboardingLoginType == "agencyLogin") {
      if (this.global.clientId != null && this.global.clientId != undefined && this.global.clientId != '00000000-0000-0000-0000-000000000000') {
        let params = new URLSearchParams();
        params.append("clientId", this.global.clientId);
        this.reportClientId = this.global.clientId;
        this.budgetform.getAllBudgetsForClient(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
          this.allBudgetDropDown = data;
        });
      }

    } else if (this.global.OnboardingLoginType == "onboardLogin") {
      this.budgetform.getAllBudgetsForOnboardClient().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.allBudgetDropDown = data;
      });

    }

  }

  refresh() {
    this.GetClientEvaluation.field = this.GetClientEvaluation.orderColumn = "clientName";
    this.GetClientEvaluation.matchCase = false;
    this.GetClientEvaluation.operator = "startswith";
    this.GetClientEvaluation.value = "";
    this.GetClientEvaluation.type = 'string';
    this.GetClientEvaluation.status = this.status = "Active";
    this.getOnBoardFilter();
  }

  getOnBoardFilter() {
    if (this.bugetInput.clientId != '00000000-0000-0000-0000-000000000000') {
      this.GetClientEvaluation.clientId = this.bugetInput.clientId;
    }
    else {
      this.GetClientEvaluation.clientId = this.filterbo.clientId;
      this.GetClientEvaluation.importdate = (this.filterbo.importdate != null && this.filterbo.importdate != '' && this.filterbo.importdate != undefined) ? (new Date(new Date(this.filterbo.importdate).toDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "") : null;

    }
    if (this.GetClientEvaluation.clientId == null) {
      this.GetClientEvaluation.clientId = '00000000-0000-0000-0000-000000000000'
    }
    if (this.global.LoginEntityType == 'ADMIN') {
      if (this.global.globalAgencyId != null && this.global.globalAgencyId != undefined && this.global.globalAgencyId != '' && this.global.globalAgencyId != '00000000-0000-0000-0000-000000000000') {
        this.budgelist.exceuteOnboardEmployee(this.GetClientEvaluation);
        this.dataOnBoardclient.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
          this.OnboardList = data.result;
        })
      }

    }
    else {
      this.budgelist.exceuteOnboardClient(this.GetClientEvaluation);
      this.dataOnBoardclient.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.OnboardList = data.result;
      })
    }

  }

  datachangeonBoardEmp(state) {
    this.ftype = (state.action.requestType).toString();
    if (this.ftype != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.GetClientEvaluation.orderColumn = state.sorted[0].name;
        this.GetClientEvaluation.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (this.ftype == "filtering" && state.action.action != "clearFilter") {
      this.GetClientEvaluation.field = state.action.currentFilterObject.field;
      this.GetClientEvaluation.matchCase = state.action.currentFilterObject.matchCase;
      this.GetClientEvaluation.operator = state.action.currentFilterObject.operator;
      this.GetClientEvaluation.value = state.action.currentFilterObject.value;
      if(this.GetClientEvaluation.type == 'number'){
        this.GetClientEvaluation.type = (this.GetClientEvaluation.value != null && this.GetClientEvaluation.value != undefined)
        ? this.GetClientEvaluation.type.toString() : null;
      }
      if(this.GetClientEvaluation.field == 'totalAmt' || this.GetClientEvaluation.field == 'unusedAmt'){
        this.GetClientEvaluation.type = 'decimal';
      }
    }
    else {
      if (this.ftype == "filtering" && state.action.action == "clearFilter") {
        this.GetClientEvaluation.field = this.GetClientEvaluation.orderColumn = "clientName";
        this.GetClientEvaluation.matchCase = false;
        this.GetClientEvaluation.operator = "startswith";
        this.GetClientEvaluation.value = "";
        this.GetClientEvaluation.type = 'string';
      }
    }
    if((this.GetClientEvaluation.type != 'string') && this.GetClientEvaluation.value == null || this.GetClientEvaluation.value == undefined || this.GetClientEvaluation.value){
      this.GetClientEvaluation.field = "clientName";
      this.GetClientEvaluation.matchCase = false;
      this.GetClientEvaluation.operator = "startswith";
      this.GetClientEvaluation.type = 'string';
      this.GetClientEvaluation.value = "";
      if(this.ftype == 'filtering') this.toasterservie.error('Please Enter Valid Input');
    }
    if (this.ftype == "paging" && state.action.name == "actionBegin") {
    }
    this.getOnBoardFilter();
  }

  OnBoardActionComplete(args) {
    this.GetClientEvaluation.currentpageno = this.grid.pageSettings.currentPage;
    this.GetClientEvaluation.pageitem = this.grid.pageSettings.pageSize;
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.GetClientEvaluation.type = args.columnType
    }
  }
  onResize(args) {
    const column = this.grid.getColumnByField(args.column.field)
    column.width = args.column.width;
    this.ColumnArray.forEach(element => {
      if (element.column == column.headerText) {
        element.width = parseInt(column.width.toString());
      }

    });
  }

  editbudget(data) {
    this.radioview = ''
    this.BudgetImportData.id = data.id;
    let param = new URLSearchParams();
    param.append("Id", this.BudgetImportData.id);
    if (this.global.LoginUserType.toUpperCase() == 'ONBOARD') {
      this.budgetplanservice.getbudgetBOOnboard(param).subscribe((data: any) => {
        this.budgetImprtPlan = data;
        this.budgetImprtPlan.id = this.BudgetImportData.id;

      });
    }
    else {
      this.budgetplanservice.getbudgetBO(param).subscribe((data: any) => {
        this.budgetImprtPlan = data;
        this.budgetImprtPlan.id = this.BudgetImportData.id;
      });
    }
  }

  getAllClientDropDown() {
    this.budgetform.GetAllClientsDropDownbyAgency().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.allClientDropDown = data;
      this.allClientDropDown.forEach(e => {
        e.id = e.id;
      });
      this.ClinetDropDown = this.allClientDropDown.filter(e => e.status == "ACTIVE");
    });

  }

  getAllBudgetsForClient() {
    if (this.bugetInput.clientId != '00000000-0000-0000-0000-000000000000') {
      this.reportClientId = this.bugetInput.clientId;
    }

    let params = new URLSearchParams();
    params.append("clientId", this.reportClientId.toString());
    this.budgetform.getAllBudgetsForClient(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.allBudgetDropDown = data;
    });
  }
  newdates(event, type, name) {
    if (type == "inputchage") {
      if (name == 'importdate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.filterbo.importdate = val1;
        }
      }
    }
    if (type == "datechagned") {
      if (name == 'importdate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.filterbo.importdate = val1;
        }
      }
    }
  }

  gettoken() {
    return new Promise((resolve, rejects) => {
      this.budgetform
        .getpowerbiToken()
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data: any) => {
            this.Token = data;
            resolve(data);
          },
          (error: HttpErrorResponse) => {
            resolve(error.message);
          }
        );
    });
  }
  gettokenForOnboard() {
    return new Promise((resolve, rejects) => {
      this.budgetform
        .getpowerbiTokenForOnboard()
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data: any) => {
            this.Token = data;
            resolve(data);
          },
          (error: HttpErrorResponse) => {
            resolve(error.message);
          }
        );
    });
  }

  showReport() {
    let filterType: '0' | '1';

if (this.isDaily) {
  filterType = '1';
} else if (this.isWeekly) {
  filterType = '0';
} else {
  filterType = '1'; // default
}
    let currentTime = this.datepipe.transform(new Date(), "MM/dd/yyyy hh:mm a");
    this.reportcontain = true;
    let reportId = this.ReportType == "detail" ? this.configuration.utilizationReportId : this.configuration.utilizationSummaryReportId;
    if (this.global.OnboardingLoginType == "agencyLogin") {
      this.gettoken().then((token) => {
        document.getElementById("openReportModal").click();
        let embedUrl = "";
        let embedReportId = "";
        if(this.ReportType == "detail") //Utilization detailed report
      {
      embedUrl =
        "https://app.powerbi.com/rdlEmbed?reportId=" +
        reportId +
        // "&groupId=" +
        // this.configuration.PowerBIWorkSpace +
        "&rp:agencyId=" +
        this.global.globalAgencyId +
        "&rp:clientId=" +
        this.reportClientId +
        "&rp:budgetId=" +
        this.selectedBudgetId +
        "&rp:ExecTime=" +
        currentTime +   
        "&rp:filtertype_isdaily=" +
        filterType +
        "&filterPaneEnabled=False&rdl:parameterPanel=hidden";
      }
      else{ //Utilization summary report
        embedUrl =
          "https://app.powerbi.com/rdlEmbed?reportId=" +
          reportId +
          "&rp:agencyId=" +
          this.global.globalAgencyId +
          "&rp:clientId=" +
          this.reportClientId +
          "&rp:budgetId=" +
          this.selectedBudgetId +
          "&rp:ExecTime=" +
          currentTime +
          "&filterPaneEnabled=False&rdl:parameterPanel=hidden";
      }
        embedReportId = reportId;
        let config = {
          type: "report",
          tokenType: pbi.models.TokenType.Aad,
          accessToken: token[0],
          embedUrl: embedUrl,
          id: embedReportId,
          settings: {},
          viewmode: pbi.models.ViewMode.View,
        };
        let reportContainer = this.reportContainer.nativeElement;
        let powerbi = new pbi.service.Service(
          pbi.factories.hpmFactory,
          pbi.factories.wpmpFactory,
          pbi.factories.routerFactory
        );
        let report = powerbi.embed(reportContainer, config);
        report.off("loaded");
        report.on("loaded", () => { });
    });

    } else if (this.global.OnboardingLoginType == "onboardLogin") {

      this.gettokenForOnboard().then((token) => {
        document.getElementById("openReportModal").click();
        let embedUrl = "";
        let embedReportId = "";
        embedUrl =
          "https://app.powerbi.com/rdlEmbed?reportId=" +
          reportId +
          "&rp:agencyId=" +
          this.decodedToken.AGENCYID +
          "&rp:clientId=" +
          this.decodedToken.LOGINENTITYID +
          "&rp:budgetId=" +
          this.selectedBudgetId +
          "&rp:ExecTime=" +
          currentTime +
          "&filterPaneEnabled=False&rdl:parameterPanel=hidden";
        embedReportId = reportId;
        let config = {
          type: "report",
          tokenType: pbi.models.TokenType.Aad,
          accessToken: token[0],
          embedUrl: embedUrl,
          id: embedReportId,
          settings: {},
          viewmode: pbi.models.ViewMode.View,
        };
        let reportContainer = this.reportContainer.nativeElement;
        let powerbi = new pbi.service.Service(
          pbi.factories.hpmFactory,
          pbi.factories.wpmpFactory,
          pbi.factories.routerFactory
        );
        let report = powerbi.embed(reportContainer, config);
        report.off("loaded");
        report.on("loaded", () => { });
      });
    }

  }

  closemodal() {
    this.reportcontain = false;
    document.getElementById("openReportModal").click();
  }

  BudgetCreateupdate() {
    this.Basic.isbasicview = null;
    this.Basic = new BasicAdvance();
    this.radioadd = ''
  }

  show() {
    this.grid.columnChooserModule.openColumnChooser(500, 50);
  }
  // ======================================================view change=========================================================
  GetBudgetLog(data) {
    let param = new URLSearchParams();
    param.append("Id", data.id);
    this.budgetplanservice.getbudgetLog(param).subscribe((data: any) => {
      data.filter(e => e.createdDateTime = this.datepipe.transform(e.createdDateTime, "MM/dd/yyyy hh:mm a"))
      this.LogTable = data
    });
  }

  closelog() {
    // this.initialPage1 = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    this.gridlog.pageSettings.currentPage = 1
    this.gridlog.pageSettings.pageSize = 10
  }

}

